"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUpperCaseWithUnderscores = exports.stripHtmlTags = exports.normalize = exports.removeBlankSpaces = exports.cleanTextQuotes = void 0;
var stripHtmlTags = function (s) { return s.replace(/></g, '> <').replace(/<[^>]*>?/gm, ''); };
exports.stripHtmlTags = stripHtmlTags;
/**
 * Strip double spaces & diacritics, trim, and optionally convert to lower or upper case.
 * Diacritics are converted using approach described
 * in https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
 * @param text string to normalize
 * @param toCase specify if the text should be lower or upper case. If not specified, the case is not changed.
 * @returns normalized string
 */
var normalize = function (text, toCase) {
    var normalizedTest = text
        .replace(/\s\s+/g, ' ')
        .replace(/[’]/g, "'")
        .normalize('NFD') // split an accented letter in the base letter and the accent like ("éô" in "e'o^")
        .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents ("e'o^" => "eo")
        .trim();
    switch (toCase) {
        case 'lower':
            return normalizedTest.toLowerCase();
        case 'upper':
            return normalizedTest.toUpperCase();
        default:
            return normalizedTest;
    }
};
exports.normalize = normalize;
var cleanTextQuotes = function (initialText) {
    // we allow string beginning or spaces before the quotes
    // we allow end of string, spaces and punctuation after the quotes
    var afterSymbols = '[\\s.?!;,]';
    var replacementPattern = '$1“$2”$3';
    var quoteRegex = function (openingQuote, endingQuote) {
        var pattern = "(^|\\s)".concat(openingQuote, "(\\s?.+?\\s?)").concat(endingQuote || openingQuote, "(").concat(afterSymbols, "|$)");
        return new RegExp(pattern, 'gi');
    };
    return (initialText
        // french quotes
        .replace(quoteRegex('«', '»'), replacementPattern)
        // double quotes
        .replace(quoteRegex('"'), replacementPattern)
        // single quotes
        .replace(quoteRegex("'"), replacementPattern));
};
exports.cleanTextQuotes = cleanTextQuotes;
var removeBlankSpacesFromString = function (text) {
    return text
        .trim()
        .replace(/\s{2,}/g, ' ')
        .replace(' ,', ',');
};
function removeBlankSpacesOverload(data) {
    if (typeof data === 'string') {
        return removeBlankSpacesFromString(data);
    }
    if (Array.isArray(data)) {
        return data.map(function (element) { return removeBlankSpacesOverload(element); });
    }
    if (data && typeof data === 'object' && !(data instanceof Date)) {
        return Object.entries(data).reduce(function (cleaned, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            return (__assign(__assign({}, cleaned), (_b = {}, _b[key] = removeBlankSpacesOverload(value), _b)));
        }, {});
    }
    return data;
}
exports.removeBlankSpaces = removeBlankSpacesOverload;
/**
 * Converts a given string to uppercase and replaces spaces with underscores.
 *
 * This function first normalizes the input string to uppercase using the `normalize` function.
 * Then it splits the string into words and joins them with underscores.
 *
 * @param {string} text - The input string to be converted.
 * @returns {string} The converted string in uppercase with spaces replaced by underscores.
 */
var toUpperCaseWithUnderscores = function (text) {
    return normalize(text, 'upper').split(' ').join('_');
};
exports.toUpperCaseWithUnderscores = toUpperCaseWithUnderscores;
//# sourceMappingURL=text.js.map